import { ESPACES } from "../../../hooks/useEspaceActif/useEspaceActif";
import { estClientQuittancePersonnel } from "../../../helpers/ficheClient";

// Filtre d'affichage par espace (PER-2211) : en espace particulier seules les
// quittances de la fiche personnelle sont proposées au paiement, en espace
// entreprise seules celles des sociétés — même règle que la page Contrats
// (PER-2209). Sans espace, aucun filtre (comportement historique).
export const filtrerQuittancesParEspace = (quittances, espace) => {
  if (espace !== ESPACES.PARTICULIER && espace !== ESPACES.ENTREPRISE) {
    return quittances;
  }
  const vouluPersonnel = espace === ESPACES.PARTICULIER;
  return quittances.filter(
    (quittance) => estClientQuittancePersonnel(quittance.client) === vouluPersonnel
  );
};

/* Structure produite :
  {
    "<clientId>": {
      client: {client},
      contrats: [
        { id, typeProduit, numero, titre, objet, compagnie,
          quittances: [{ id, debutPeriode, dateLimite, finPeriode, restantDu, isPaid }] }
      ]
    }
  }
*/
export const grouperQuittancesParClient = (quittances) => {
  const contractsByClient = {};

  quittances.forEach((quittance) => {
    const clientId = quittance.client.id;

    if (!contractsByClient[clientId]) {
      contractsByClient[clientId] = {
        client: quittance.client,
        contrats: [],
      };
    }

    const contract = {
      id: quittance.contrat.id,
      typeProduit: quittance.contrat.typeProduit,
      numero: quittance.contrat.numero,
      titre: quittance.contrat.titre,
      objet: quittance.contrat.objet,
      compagnie: quittance.contrat.compagnie,
      quittances: [],
    };

    const existingContract = contractsByClient[clientId].contrats.find(
      (c) => c.id === contract.id
    );

    if (!existingContract) {
      contractsByClient[clientId].contrats.push(contract);
    }

    const quittanceToAdd = {
      id: quittance.id,
      debutPeriode: quittance.debutPeriode,
      dateLimite: quittance.dateLimite,
      finPeriode: quittance.finPeriode,
      restantDu: quittance.restantDu,
      isPaid: quittance.isPaid,
    };

    (existingContract || contract).quittances.push(quittanceToAdd);
  });

  return contractsByClient;
};
